import { Box, Typography, Paper, Container } from "@mui/material";
import useAdminStore from "../store/adminStore";

const Main = () => {
    const company = useAdminStore((s) => s.company);
    const companyName = company?.name || ""

    return (
        <Container maxWidth="lg">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "60vh",
                    textAlign: "center",
                }}
            >
                <Paper
                    elevation={6}
                    sx={{
                        p: 6,
                        borderRadius: 4,
                        background: (theme) =>
                            theme.palette.mode === "dark"
                                ? "linear-gradient(135deg, rgba(240, 85, 19, 0.15) 0%, rgba(240, 85, 19, 0.05) 100%)"
                                : "linear-gradient(135deg, rgba(240, 85, 19, 0.1) 0%, rgba(240, 85, 19, 0.03) 100%)",
                        border: (theme) =>
                            `1px solid ${theme.palette.mode === "dark" ? "rgba(240, 85, 19, 0.3)" : "rgba(240, 85, 19, 0.2)"}`,
                        maxWidth: 600,
                        width: "100%",
                    }}
                >
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{
                            fontWeight: 600,
                            mb: 2,
                            color: "primary.main",
                            letterSpacing: 1,
                        }}
                    >
                        Welcome to
                    </Typography>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontWeight: 700,
                            color: "text.primary",
                            textTransform: "capitalize",
                            letterSpacing: 0.5,
                        }}
                    >
                        {companyName}
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default Main;

